// © Microsoft Corporation. All rights reserved.

import { canUseDOM } from "@msnews/isomorphic-util";

/**
 * If user is navigating away or not.
 */
let userNavigatingAway = false;

if (canUseDOM()) {
    // Sets isUserNavigatingAway = true when user is navigating away.
    window.addEventListener("beforeunload", function () {
        userNavigatingAway = true;
    });
}

/**
 * Is user navigating away.
 * @returns true if user is navigating away.
 */
export function isUserNavigatingAway(): boolean {
    return userNavigatingAway;
}